import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const POLICIES = [
  {
    id: "equal-access",
    title: "1. Equal Access & Dignity Policy",
    body: [
      "Every citizen has the right to own land, build a home, and invest in their own country — this is your birthright.",
      "We never ask about, check, or record your immigration status in the country where you live now — it is private and not our business.",
      "We only verify you are a citizen of the country where you want to buy property — using official national ID or passport from that nation only.",
      "No discrimination — everyone is treated with equal respect, dignity, and fairness.",
      "MAVULA Investment is a property and home ownership scheme — NOT a general money transfer or remittance service.",
      "We do not offer cash withdrawal services — all funds are used only for your property or investment in your home country.",
    ],
  },
  {
    id: "privacy",
    title: "2. Privacy & Confidentiality Policy",
    body: [
      "Your personal information is kept strictly private, safe, and secure — never shared without your permission.",
      "We do not collect, store, or share any information about your immigration status in your current country of residence.",
      "We only keep what is needed: your full name, contact, and proof of citizenship in the investment country — nothing extra.",
      "All records are protected, and you can ask to see or update your information anytime.",
      "Data we log for security & attribution: when you visit an agent shortlink (a link of the form /r/MV-AGT-XXXXX), we record the agent code, your IP address, browser user-agent, and timestamp so we can (a) attribute your registration to the referring agent and (b) protect the platform from abuse. This log is accessible only to MAVULA administrators.",
      "Data retention & deletion: you can permanently delete your account from your dashboard (see 'Your account' panel). Personal fields (name, phone, addresses) are removed immediately. Payment records are anonymised (your user identity is stripped) but kept for finance/audit purposes as required by law.",
      "Rights (GDPR / POPIA): you may request access, correction, deletion, or export of your personal data by emailing Sebata@pulalove.com. We respond within 30 days.",
    ],
  },
  {
    id: "terms",
    title: "3. Terms & Conditions",
    body: [
      "Service Type: MAVULA Investment is a property and home ownership scheme, not a bank or general money service.",
      "Fund Use: All money you send is held securely in your personal investment account, and only paid directly toward your property, land, or home building costs — never sent as cash or used for anything else.",
      "Rates & Terms: deposit, instalment amount, term and any applicable rate are all set inside your individual signed project contract with the local developer. All figures shown anywhere on this website are illustrative only and are not a financial promotion, offer or forecast. MAVULA Investment Ltd (UK Company No. 17368822) is not authorised or regulated by the FCA and is not a mortgage lender, credit provider or investment firm.",
      "Ownership: Title deed registered in your name once fully paid — fully yours, per the property registry of the country where the property is located.",
      "Legal: All agreements follow the laws of the country where your property is located. Where local law conflicts with anything published here, local law wins.",
      "No investment advice: Nothing on this site is financial or legal advice. You should take independent legal advice before signing any sale, mortgage or inheritance document.",
      "Right of withdrawal: You may cancel your reservation at any time before signing the sale agreement and receive a full refund of your deposit within 14 working days.",
      "Complaints: Email Sebata@pulalove.com or WhatsApp +44 7424 311882. We respond to complaints within 5 working days and escalate to independent mediation on request.",
    ],
  },
  {
    id: "payments",
    title: "4. Payment & Protection Policy",
    body: [
      "Secure ways to pay: bank transfer, trusted local agents, or deposit points — simple options even without a bank account.",
      "Every payment tracked with full receipts & statements — check balance anytime via app, WhatsApp, or message.",
      "No extra charges for early payments.",
      "Hard Times Support: If you struggle to pay, talk to us — we will find a fair solution together. Do not hide, we are here to help.",
    ],
  },
  {
    id: "compliance",
    title: "5. Compliance & Integrity Policy",
    body: [
      "We follow all legal requirements for property transactions in each country we work in.",
      "We verify citizenship to ensure funds go to the rightful owner — no illegal or anonymous transactions.",
      "We operate fully legally and transparently at all times.",
    ],
  },
  {
    id: "cookies",
    title: "6. Cookie Policy",
    body: [
      "We use only essential cookies required to keep you signed in securely (session cookie) and to remember your language and low-data preferences.",
      "We do not use third-party advertising or tracking cookies. We do not sell your data.",
      "You can control cookies via the consent banner shown on your first visit, and by clearing your browser storage at any time. Some site features (like staying signed in) will not work without the essential cookies.",
      "If you have a cookie or privacy question, WhatsApp +44 7424 311882 — we reply within 24 hours.",
    ],
  },
];

export default function PoliciesPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 md:px-8 py-16 md:py-20">
      <div className="mv-eyebrow"><span style={{color:"var(--mv-gold)"}}>Policies</span></div>
      <h1 className="font-display text-3xl md:text-4xl lg:text-5xl mv-green-text mt-3 leading-tight">
        Clear policies. <span className="font-accent italic" style={{color:"var(--mv-gold)"}}>No small print.</span>
      </h1>
      <p className="mt-4 text-[15px] max-w-2xl" style={{color:"var(--mv-muted)"}}>
        Everything we stand for — plainly written, easy to check. Tap any section to read it in full.
      </p>

      <div className="mt-10 mv-card p-2 md:p-4">
        <Accordion type="multiple" className="w-full">
          {POLICIES.map((p) => (
            <AccordionItem key={p.id} value={p.id} id={p.id} data-testid={`policy-${p.id}`}>
              <AccordionTrigger className="text-left font-display text-lg md:text-xl mv-green-text px-3 md:px-4">
                {p.title}
              </AccordionTrigger>
              <AccordionContent className="px-3 md:px-4 pb-6">
                <ul className="space-y-2.5 text-[14.5px]" style={{color:"var(--mv-muted)"}}>
                  {p.body.map((b, i) => (
                    <li key={i} className="leading-relaxed">• {b}</li>
                  ))}
                </ul>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
